import { render, staticRenderFns } from "./parcelDetails copy.vue?vue&type=template&id=572ff3ad&scoped=true&"
import script from "./parcelDetails copy.vue?vue&type=script&lang=js&"
export * from "./parcelDetails copy.vue?vue&type=script&lang=js&"
import style0 from "./parcelDetails copy.vue?vue&type=style&index=0&id=572ff3ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ff3ad",
  null
  
)

export default component.exports